import { Box, Typography } from '@mui/material';
import { setFooterHeight } from '@src/shared/zustand';
import { Grid, SecondaryButton } from '@src/shared/ui';
import React, { useEffect, useRef } from 'react';
import { useRedirectHandler } from '@src/shared/hooks/use-redirect-handler';

export type FooterProps = {
  className?: string;
  id?: string;
};

export const Footer: React.FC<FooterProps> = ({ className, id }) => {
  const ref = useRef(null);

  const { toWhatsAppSupport } = useRedirectHandler();

  useEffect(() => {
    const atualizarAltura = () => {
      if (ref?.current?.clientHeight) {
        setFooterHeight(ref?.current?.clientHeight);
      }
    };

    const observer = new ResizeObserver(atualizarAltura);
    if (ref?.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref?.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return (
    <Grid
      id={id}
      ref={ref}
      className={`
        -z-10
        bg-brand-blue-midnight-30
        sm:max-h-[232px]
        max-h-[296px]
        ${className}
      `}
    >
      <img
        className={`
              col-span-2
              max-w-24
              h-9
              py-[6px]
              sm:py-0
              sm:h-12
              mt-10
              sm:mt-12
            `}
        src='/pagol.svg'
        alt='Logo Pagol'
      />
      <Box
        className={`
              w-full
              mt-10
              col-span-2
              col-end-5
              flex
              flex-row-reverse

              sm:col-span-3
              sm:col-end-9
              md:col-end-13
              sm:mt-12
              sm:h-12
            `}
      >
        <SecondaryButton
          onClick={toWhatsAppSupport}
          className={`
              -z-0
              min-w-[124px]
              text-white
              text-[14px]

              border-white
              rounded-xl

              font-inter
              font-semibold

              leading-6
              p-3

              w-[124px]
              h-[36px]

              hover:border-[#C1D8EA]
              hover:text-[#C1D8EA]

              sm:h-12
              sm:w-[296px]
              sm:text-[16px]
            `}
        >
          Fale conosco
        </SecondaryButton>
      </Box>
      <Typography
        className={`
          col-span-4
          font-inter
          text-sm
          text-secondary-10
          text-brand-blue-rock
          font-normal
          border-t
          my-10
          pt-10

          sm:pt-0
          sm:border-t-brand-blue-midnight-30

          sm:text-sm
          sm:col-span-8
          md:col-span-12
        `}
      >
        © 2023 PaGol. Todos os direitos reservados. PaGol Sociedade de Crédito
        Direto S.A. Alameda Rio Negro, nº 585, Conjunto 41 – Bloco B,
        Alphaville, CEP 06.454-000, Barueri, Estado de São Paulo. CNPJ/ME no.
        48.176.336/0001-36
      </Typography>
    </Grid>
  );
};
